import axios from 'axios'
import { addData, baseUrl, loadData } from '../../config/data'

export const loadMyApplicationOverview = async ({ userToken }) => {
  if (!userToken) return null

  const response = await loadData({
    url: 'Candidates/my-applications',
    userToken,
  })

  return Array.isArray(response?.data) ? response.data : null
}

export const loadMyApplicationDetail = async ({
  interviewInvitationID,
  userToken,
}) => {
  if (!interviewInvitationID || !userToken) return null

  const response = await loadData({
    url: 'JobInterviewSlots',
    params: [{ title: 'InterviewInvitationID', value: interviewInvitationID }],
    userToken,
    throwOnError: true,
  })

  return response || null
}

export const loadMyCandidateJobOffer = async ({
  jobID,
  candidateID,
  userToken,
}) => {
  if (!jobID || !candidateID || !userToken) return null

  const response = await loadData({
    url: 'CandidateJobOffer/GetOffer',
    params: [
      { title: 'JobId', value: jobID },
      { title: 'CandidateId', value: candidateID },
    ],
    userToken,
  })

  return response || null
}

export const confirmMyJobOffer = async ({
  candidateJobOfferID,
  startWorkDate,
  userToken,
}) => {
  return addData({
    url: 'CandidateJobOffer/ConfirmOffer',
    reqBody: {
      candidateJobOfferID,
      startWorkDate,
    },
    userToken,
  })
}

export const resendMyJobOfferOtp = async ({
  candidateJobOfferID,
  startWorkDate,
  userToken,
}) => {
  return addData({
    url: 'CandidateJobOffer/ResendOfferOTP',
    reqBody: {
      candidateJobOfferID,
      startWorkDate,
    },
    userToken,
  })
}

export const verifyMyJobOfferOtp = async ({
  candidateJobOfferID,
  otpCode,
  startWorkDate,
  userToken,
}) => {
  return addData({
    url: 'CandidateJobOffer/VerifyOfferOTP',
    reqBody: {
      candidateJobOfferID,
      otpCode,
      startWorkDate,
    },
    userToken,
  })
}

export const submitMyPreOnBoarding = async ({ reqBody, userToken }) => {
  return addData({
    url: 'CandidateJobOffer/SubmitPreOnBoarding',
    reqBody,
    userToken,
  })
}

export const uploadMyPreOnBoardFile = async ({
  file,
  userToken,
  candidateJobOfferID,
  documentType,
}) => {
  try {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('candidateJobOfferID', candidateJobOfferID)
    formData.append('documentType', documentType)

    const response = await axios.post(
      `${baseUrl}/CandidateJobOffer/UploadPreOnBoardingFile`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    return response.data
  } catch (error) {
    return error?.response?.data?.message || error?.message || 'Upload failed'
  }
}

export const uploadMyTechnicalTestFile = async ({ file, userToken }) => {
  try {
    const formData = new FormData()
    formData.append('file', file)

    const response = await axios.post(
      `${baseUrl}/Candidates/UploadTechnicalTestFile`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    return response.data
  } catch (error) {
    return error?.response?.data?.message || error?.message || 'Upload failed'
  }
}

export const submitMyTechnicalTest = async ({
  candidateID,
  uploadTechnical,
  userToken,
}) => {
  try {
    const response = await axios.patch(
      `${baseUrl}/Candidates/${candidateID}/UpdateAssessmentTechnicalTest`,
      {
        uploadTechnical,
      },
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      },
    )

    return response.data
  } catch (error) {
    return error?.response?.data?.message || error?.message || 'Submit failed'
  }
}

export const submitMyApplicationSchedule = async ({
  interviewInvitationID,
  interviewSlotID,
  userToken,
}) => {
  return addData({
    url: 'JobInterviewSlots',
    reqBody: {
      interviewInvitationID,
      interviewSlotID,
    },
    userToken,
  })
}

export const requestMyApplicationReschedule = async ({
  interviewInvitationID,
  requestedDate,
  note,
  userToken,
}) => {
  return addData({
    url: 'JobInterviewSlots/reschedule-request',
    reqBody: {
      interviewInvitationID,
      requestedDate,
      note,
    },
    userToken,
  })
}

export const loadHolidayDates = async ({ startDate, endDate, userToken }) => {
  if (!startDate || !endDate || !userToken) return []

  const response = await loadData({
    url: 'Holidays',
    params: [{ title: 'date', value: `${startDate}|${endDate}` }],
    userToken,
  })

  const items = Array.isArray(response?.data) ? response.data : []

  return items
    .map((item) => item?.transDate)
    .filter((item) => typeof item === 'string' && item.trim() !== '')
}
